import { Fragment } from 'react';
import './index.css';
function HelpMDHPage() {
    return <Fragment >
        <div className="help-mdh-page">
            <div className="content mb-0">
                <img src="assets/img/mdh/1.png" alt="" />
                <img className="mv-4" src="assets/img/mdh/2.png" alt="" />
                <a href="https://ux-cdn.cencosudx.io/milocal/pdf/apertura-cierre-tienda-mdh.pdf" target="_blank">
                    <img className='card' src="assets/img/mdh/3.png" alt="" />
                </a>
                <a href="https://ux-cdn.cencosudx.io/milocal/pdf/recepcion-mercaderia-subgerente-mdh.pdf" target="_blank">
                    <img className='card' src="assets/img/mdh/4.png" alt="" />
                </a>
                <a href="https://ux-cdn.cencosudx.io/milocal/pdf/recepcion-mercaderia-jefe-seccion-mdh.pdf" target="_blank">
                    <img className='card' src="assets/img/mdh/5.png" alt="" />
                </a>
                <img className="mv-6" src="assets/img/mdh/6.png" alt="" />
                <img src="assets/img/mdh/7.png" alt="" />
            </div>
        </div>

    </Fragment>

}

export default HelpMDHPage;
